import {onFind} from "@elements/init-modules-in-scope";
import {findIn, trigger} from "@elements/dom-utils";

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm';
onFind('[data-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as ajaxFormMap from './scripts/ajax-form-map';
ajaxFormMap.init();

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as rangeSlider from '@elements/range-slider';
// rangeSlider.init();
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onSet: sliderObj => trigger('change', sliderObj.element),
        onUpdate: (sliderObj) => {
            let value = sliderObj.value,
                decimalPlaces = sliderObj.decimalPlaces,
                prefix = slider.getAttribute('data-range-slider-prefix') ? ' ' + slider.getAttribute('data-range-slider-prefix'): '';

            if ( sliderObj.handle === 0 ) {
                findIn('.js-range-slider__val-min', slider).value = value.toFixed(decimalPlaces) + prefix;
            } else {
                findIn('.js-range-slider__val-max', slider).value = value.toFixed(decimalPlaces) + prefix;
            }
        }
    },{
        slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max'
    });
});

import * as filterDropdown from './scripts/filter-dropdown';
filterDropdown.init();

import * as filterBar from './scripts/filter-bar';
filterBar.init();

import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init();